module.exports = __webpack_public_path__ + "img/chat3-3.8545db57.png";